import React from "react";

const TechTag = ({ tag }) => {
  return <div className="tech__tag">{tag}</div>;
};

export default TechTag;
